export default __webpack_public_path__ + "static/media/gen0.8c6642a7.jpg";